import * as yup from 'yup';
import { VALIDATION } from 'Helpers/validations';
import { EditRoleFormValues } from './EditRole.types';

export const schema = yup
	.object()
	.shape<Partial<Record<keyof EditRoleFormValues, yup.AnySchema>>>({
		role: VALIDATION.baseName.label('role.editRole.fields.name').required()
	});
